import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=159216d0&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('159216d0')) {
      api.createRecord('159216d0', component.options)
    } else {
      api.reload('159216d0', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=159216d0&", function () {
      api.rerender('159216d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Iutk1RwNx0Hc/JS/comp/ImgFallback.vue"
export default component.exports